import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { EntitySalesCreditTermsImportFileHelperContainerModel } from '../../../../../../models/aggregates/erp/credit/index';

@Injectable({
  providedIn: 'root'
})
export class EntitySalesCreditTermsImportFileHelperService extends BaseApiTemplateService<EntitySalesCreditTermsImportFileHelperContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-sales-credit-term-import-file-helpers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'entity-sales-credit-term-import-file-helpers/backoffice-ep';
    this.httpClient = http;
  }
}